import {
  AuthApiFactory,
  Configuration,
  PaymentsApiFactory,
  ProfileApiFactory,
  SubscriptionsApiFactory,
  UsersApiFactory
} from '@growdash/identity/generated';
import { getAccessToken } from '@utils/session';
import axios from 'axios';

export const authAPIBasePath =
  import.meta.env.VITE_REACT_APP_IDENTITY_API_URL ??
  'https://identity.dev.mygrowdash.com';

const baseConfig = {
  basePath: authAPIBasePath
};

const axiosInstance = axios.create({
  baseURL: authAPIBasePath
});

axiosInstance.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const apiQueryConfig = new Configuration({
  ...baseConfig,
  accessToken: () => getAccessToken() || ''
});

export let identityClient = {
  authAPI: AuthApiFactory(apiQueryConfig),
  usersAPI: UsersApiFactory(apiQueryConfig),
  selfserveAPI: SubscriptionsApiFactory(apiQueryConfig),
  paymentsAPI: PaymentsApiFactory(apiQueryConfig),
  profileAPI: ProfileApiFactory(apiQueryConfig)
};

export const authorizeIdentityService = (accessToken: string | null) => {
  if (accessToken) {
    const config = { ...baseConfig, accessToken };
    const configuration = new Configuration(config);
    identityClient.authAPI = AuthApiFactory(configuration);
    identityClient.usersAPI = UsersApiFactory(configuration);
    identityClient.selfserveAPI = SubscriptionsApiFactory(configuration);
    identityClient.paymentsAPI = PaymentsApiFactory(configuration);
    identityClient.profileAPI = ProfileApiFactory(configuration);
  } else {
    delete apiQueryConfig.accessToken;
    identityClient.authAPI = AuthApiFactory(apiQueryConfig);
    identityClient.usersAPI = UsersApiFactory(apiQueryConfig);
    identityClient.selfserveAPI = SubscriptionsApiFactory(apiQueryConfig);
    identityClient.paymentsAPI = PaymentsApiFactory(apiQueryConfig);
    identityClient.profileAPI = ProfileApiFactory(apiQueryConfig);
  }
};
